import { render, staticRenderFns } from "./tableThir.vue?vue&type=template&id=5f5c91ec&scoped=true&"
import script from "./tableThir.vue?vue&type=script&lang=js&"
export * from "./tableThir.vue?vue&type=script&lang=js&"
import style1 from "./tableThir.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5c91ec",
  null
  
)

export default component.exports